/**
 * Acorta un texto a `maximo` caracteres sin partir la última palabra y le agrega "…" (lo mismo que hacían los
 * `wrapLabels` de cada pantalla). Si cabe, lo devuelve igual. Quien muestre el texto acortado debe poner el
 * completo en un `title` (la tabla compartida lo hace sola con su input `recortes`).
 */
export function recortarTexto(texto: string | null | undefined, maximo: number): string {
  const valor = texto ?? '';
  if (valor.length <= maximo) return valor;
  let recortado = valor.slice(0, maximo);
  const ultimoEspacio = recortado.lastIndexOf(' ');
  if (ultimoEspacio > 0) recortado = recortado.slice(0, ultimoEspacio);
  return recortado.trimEnd() + '…';
}

// Propiedad (no enumerable) con la que las etiquetas acortadas de un gráfico guardan las completas
const ETIQUETAS_COMPLETAS = 'etiquetasCompletas';

/**
 * Etiquetas de un gráfico de Chart.js acortadas con `recortarTexto`. El arreglo lleva las completas en una propiedad
 * no enumerable: el tooltip (callback por defecto de main.ts) muestra el nombre completo del elemento.
 */
export function recortarEtiquetas(etiquetas: (string | null | undefined)[], maximo: number): string[] {
  const recortadas = etiquetas.map((etiqueta) => recortarTexto(etiqueta, maximo));
  Object.defineProperty(recortadas, ETIQUETAS_COMPLETAS, { value: etiquetas.map((etiqueta) => etiqueta ?? ''), enumerable: false });
  return recortadas;
}

/** La etiqueta completa del índice si el arreglo viene de `recortarEtiquetas` y esa etiqueta se acortó; si no, null. */
export function etiquetaCompleta(etiquetas: unknown, indice: number): string | null {
  const completas = (etiquetas as Record<string, unknown> | null | undefined)?.[ETIQUETAS_COMPLETAS];
  if (!Array.isArray(completas) || !Array.isArray(etiquetas)) return null;
  const completa = completas[indice];
  return typeof completa === 'string' && completa !== etiquetas[indice] ? completa : null;
}
